import styled from "styled-components";

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 20px;
  gap: 40px;

  @media (max-width: 768px) {
    min-height: 50vh;
    padding: 24px 16px;
    gap: 24px;
  }
`;

export const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 600px;
  gap: 16px;
`;

export const ErrorTitle = styled.h1`
  font-size: 120px;
  font-weight: 700;
  color: var(--primary);
  margin: 0;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 80px;
  }
`;

export const ErrorSubtitle = styled.h2`
  font-size: 32px;
  font-weight: 600;
  color: var(--neutral);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const ErrorMessage = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: var(--neutral-light);
  line-height: 24px;
  margin: 8px 0 24px;

  @media (max-width: 768px) {
    font-size: 14px;
    margin: 4px 0 16px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 480px) {
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }
`;

export const PrimaryButton = styled.button`
  padding: 14px 32px;
  background: var(--primary);
  color: var(--lightest);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;

  &:hover {
    background: var(--primary-light);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: unset;
  }
`;

export const SecondaryButton = styled.button`
  padding: 14px 32px;
  background: transparent;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 160px;

  &:hover {
    background: var(--gray-lightest);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: unset;
  }
`;

export const CityImage = styled.img`
  width: 100%;
  max-width: 800px;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  object-fit: cover;

  @media (max-width: 768px) {
    max-width: 100%;
    border-radius: 8px;
  }
`;
